export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "filter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])},
        "sort": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sort order"])},
        "reset-filters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset"])}
      },
      "fr": {
        "filter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrer"])},
        "sort": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ordre de tri"])},
        "reset-filters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réinitialiser"])}
      }
    }
  })
}
